import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form';

import { FieldCheckbox } from './field-checkbox';

interface FormFieldCheckboxProps<T extends FieldValues> extends Omit<
  React.ComponentProps<typeof FieldCheckbox>,
  'checked' | 'onCheckedChange' | 'errors'
> {
  control: Control<T>;
  name: FieldPath<T>;
}

export function FormFieldCheckbox<T extends FieldValues>({ control, name, ...rest }: FormFieldCheckboxProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FieldCheckbox
          {...rest}
          checked={field.value ?? false}
          onCheckedChange={(checked) => field.onChange(checked)}
          errors={fieldState.error ? [fieldState.error] : undefined}
        />
      )}
    />
  );
}
